import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated } from "../../config/config";

const PrivateRoute = () => {
  // Check if the user is authenticated
  const auth = isAuthenticated();
  
  // For development, log authentication status
  // if (process.env.NODE_ENV === 'development') {
  //   console.log("PrivateRoute auth check:", auth);
  // }
  
  // If authenticated, render the child routes (Outlet)
  // If not, redirect to the login page
  return auth ? <Outlet /> : <Navigate to="/signin" />;
};

export default PrivateRoute;
